// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39pfI","content":"styles_content__cOsWX"};